/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsManDeduct.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-man-deduct";

export class AutogenModelDrsManDeduct<RowType extends ModelRow> extends Endpoint<RowType, RowDrsManDeductFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsManDeduct extends ModelRow<RowDrsManDeductFields> {
	constructor(values?: Partial<RowDrsManDeductFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsManDeductFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	company_id: string;
	deduct_code_id: string;
	deduction_type: string;
	descr: string;
	employer_tax_liab: number;
	employer_tax_liab_c: string;
	employer_tax_liab_d: Date;
	employer_tax_liab_n: number;
	employer_tax_liab_r: number;
	glid: string;
	id: string;
	rate: number;
	settlement_id: string;
	short_desc: string;
	tax_code: string;
	tax_type: string;
	units: number;
}

